import React from 'react';
import styled from 'styled-components';
import Body from 'ui/Typography/Body';
import { adjustMeasurementsSystem } from 'utils/adjustMeasurementsSystem';
import { IVector2 } from '@inter-ikea-betrakta/viewer';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { LabelPosition } from '@inter-ikea-storageone/range';
import { IStorageOneTranslations } from 'contexts/serviceSettings';

const MeasurementsLabel = styled.div`
  position: absolute;
  width: ${({ theme }) => theme.space.xxl};
  height: ${({ theme }) => theme.space.l};
  display: flex;
  justify-content: center;
  user-select: none;
  border-radius: 4px;
  top: 0;
  left: 0;

  &[data-hidden='true'] {
    display: none;
  }
`;

export const getLabel = (
  dim: string,
  size: number,
  position: IVector2,
  translations: IStorageOneTranslations,
  useMetricMeasures?: boolean
) => {
  return {
    ...position,
    dim,
    size: adjustMeasurementsSystem(size, translations, useMetricMeasures, 1)
  };
};

const Label = ({ size, dim, x, y, visible, bgColor, rotation }: LabelPosition) => {
  const labelColor = bgColor ? bgColor : 'black';

  return (
    <MeasurementsLabel
      data-testid={`measurement-${dim}`}
      data-hidden={!visible || !x || !y}
      style={{
        transform: `translate(${x}px, ${y}px) translate(-50%, -50%) ${rotation ? rotation : ``}`,
        background: `${labelColor}`
      }}
    >
      <Body color={'white'} fontWeight="bold" type={ThemeFontStyleTypeEnum.bodySmall}>
        {size}
      </Body>
    </MeasurementsLabel>
  );
};

export default Label;
